import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowPickersItemStyle } from './datecalendar.theme';

export const flowDigitalClockItemStyle = (theme: Theme) => ({
  ...flowPickersItemStyle(theme),
  borderRadius: '4px',
  overflow: 'visible',
  '&:focus-visible:before': {
    inset: '-3px',
  },
});

export const flowDigitalClock: Components<Theme>['MuiDigitalClock'] = {
  styleOverrides: {
    item: ({ theme }) => flowDigitalClockItemStyle(theme),
  },
};
